import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration, MutationAiIntegrationCreateArgs } from "types/generated";

export const CREATE_AI_INTEGRATION: TypedDocumentNode<
  {
    aiIntegrationCreate: Pick<AiIntegration, "id">;
  },
  MutationAiIntegrationCreateArgs
> = gql`
  mutation CreateAiIntegration(
    $name: String!
    $description: String
    $labels: [String!]!
    $provider: String!
    $model: String!
    $apiKey: String!
    $space: ID
  ) {
    aiIntegrationCreate(
      name: $name
      description: $description
      labels: $labels
      provider: $provider
      model: $model
      apiKey: $apiKey
      space: $space
    ) {
      id
    }
  }
`;
